<template>
  <section class="block-video" :class="[background]">
    <div v-if="block.heading" class="block-text">
      <h2>{{ block.heading }}</h2>
      <p v-if="block.subHeading">{{ block.subHeading }}</p>
    </div>
    <VideoPlayerDefault class="z-40" :media="block.media" />
  </section>
</template>

<script>
import { background } from '@/mixins';
import VideoPlayerDefault from '@/components/Video/VideoPlayerDefault';

export default {
  name: 'BlockVideo',
  components: {
    VideoPlayerDefault
  },
  props: {
    block: [Array, Object]
  },
  mixins: [background]
};
</script>

<style lang="postcss" scoped>
.block-video {
  color: white;
  @apply py-32;
  @apply flex flex-col items-center justify-center;
  @screen lg {
    @apply min-h-screen;
  }
  @apply text-center;
}
.block-text {
  display: flex;
  flex-direction: column;
  @apply px-12;
  h2 {
    @apply font-ginto-black text-center;
    font-size: calc(20px + (40 - 20) * (100vw - 640px) / (1920 - 640));
    line-height: 1.375;
    margin-bottom: 1rem;
  }
  p {
    max-width: 70ch;
    font-size: calc(12px + (16 - 12) * (100vw - 640px) / (1920 - 640));
    @apply font-ginto-regular;
    a {
      @apply border-b border-brand-blue;
      @apply pb-1;
    }
    &:only-of-type {
      @apply text-center;
    }
  }
  em {
    @apply font-ginto-regular-italic;
  }
  p:not(:last-child) {
    @apply mb-8;
  }
  margin-bottom: 6rem;
}
</style>
